import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CalendarBusinessService } from 'src/app/core/business/calendar/calendar-business.service';
import { AppointmentInput } from 'src/app/core/models/calendar/appointment-input';
import { CalendarInput } from 'src/app/core/models/calendar/calendar-input';
import { ScheduleCreate } from 'src/app/core/models/settings/daily-schedule-create';
import { AppointmentsDTO } from 'src/app/domain/calendar/appointment.dto';
import { EventsDTO } from 'src/app/domain/calendar/events.dto';
import { OpenHoursDTO } from 'src/app/domain/calendar/open-hour.dto';

@Injectable({
  providedIn: 'root'
})
export class CalendarFacadeService {

  constructor(private calendarBusinessService: CalendarBusinessService) { }

  getAppointmentsList(obj: CalendarInput): Observable<EventsDTO[]> {
    return this.calendarBusinessService.getAppointmentsList(obj);
  }

  getAppointmentById(id: number): Observable<AppointmentsDTO[]> {
    return this.calendarBusinessService.getAppointmentById(id);
  }

  updateAppointment(data: AppointmentInput): Observable<AppointmentInput> {
    return this.calendarBusinessService.updateAppointment(data);
  }

  approveAndRejectAppointment(data: AppointmentInput): Observable<AppointmentInput> {
    return this.calendarBusinessService.approveAndRejectAppointment(data);
  }

  cancelAppointment(data: AppointmentInput): Observable<AppointmentInput> {
    return this.calendarBusinessService.cancelAppointment(data);
  }

  getOpenHours(obj: CalendarInput): Observable<OpenHoursDTO[]> {
    return this.calendarBusinessService.getOpenHours(obj);
  }

  getClosedHours(obj: CalendarInput): Observable<EventsDTO[]> {
    return this.calendarBusinessService.getClosedHours(obj);
  }

  createClosedHours(data: ScheduleCreate): Observable<ScheduleCreate> {
    return this.calendarBusinessService.createClosedHours(data);
  }

  getClosedHoursById(id:number): Observable<any> {
    return this.calendarBusinessService.getClosedHoursById(id);
  }

  updateClosedHours(data: ScheduleCreate): Observable<ScheduleCreate> {
    return this.calendarBusinessService.updateClosedHours(data);
  }

  appointmentValidation(data: ScheduleCreate): Observable<ScheduleCreate> {
    return this.calendarBusinessService.appointmentValidation(data);
  }
}
